import React, { useState } from "react";
import ReactCrop from "react-image-crop";
import "react-image-crop/dist/ReactCrop.css";

function ImageCropper(props) {
    const { imageToCrop, onImageCropped } = props;
    const [defaultCropConfig, setCropConfig] = useState(
        // default crop config
        {
            unit: '%',
            width: 50,
            height: 50,
            aspect: 16 / 9
        }
    );

    const [imageRef, setImageRef] = useState();

    async function cropImage(crop) {
        if (imageRef && crop.width && crop.height) {
            const croppedImage = await getCroppedImage(
                imageRef,
                crop,
                "image/png" // destination filename
            );
            onImageCropped(croppedImage);
        }
    }

    // function getCroppedImage(sourceImage, cropConfig, fileName) {
    //     const canvas = document.createElement("canvas");
    //     const scaleX = sourceImage.naturalWidth / sourceImage.width;
    //     const scaleY = sourceImage.naturalHeight / sourceImage.height;
    //     canvas.width = cropConfig.width;
    //     canvas.height = cropConfig.height;
    //     const ctx = canvas.getContext("2d");
    //
    //     ctx.drawImage(
    //         sourceImage,
    //         cropConfig.x * scaleX,
    //         cropConfig.y * scaleY,
    //         cropConfig.width * scaleX,
    //         cropConfig.height * scaleY,
    //         0,
    //         0,
    //         cropConfig.width,
    //         cropConfig.height
    //     );
    //
    //     return new Promise((resolve, reject) => {
    //         canvas.toBlob((blob) => {
    //             // returning an error
    //             if (!blob) {
    //                 reject(new Error("Canvas is empty"));
    //                 return;
    //             }
    //
    //             blob.name = fileName;
    //             // creating a Object URL representing the Blob object given
    //             // const croppedImageUrl = window.URL.createObjectURL(blob);
    //
    //             resolve(blob);
    //         }, "image/png",1);
    //     });
    // }
    const getCroppedImage = (image, crop, fileName) => {
        const canvas = document.createElement('canvas');
        const scaleX = image.naturalWidth / image.width;
        const scaleY = image.naturalHeight / image.height;
        canvas.width = Math.ceil(crop.width*scaleX);
        canvas.height = Math.ceil(crop.height*scaleY);
        const ctx = canvas.getContext('2d');
        ctx.drawImage(
            image,
            crop.x * scaleX,
            crop.y * scaleY,
            crop.width * scaleX,
            crop.height * scaleY,
            0,
            0,
            crop.width*scaleX,
            crop.height*scaleY,
        );
        // As Base64 string
        // const base64Image = canvas.toDataURL('image/jpeg');
        // As a blob
        return new Promise((resolve, reject) => {
            canvas.toBlob(blob => {
                blob.name = fileName;
                resolve(blob);
            }, 'image/png',1);
        });
    }

    return (
        <ReactCrop
            src={imageToCrop}
            crop={defaultCropConfig}
            ruleOfThirds
            onImageLoaded={(imageRef) => setImageRef(imageRef)}
            onComplete={(cropConfig) => cropImage(cropConfig)}
            onChange={(cropConfig) => setCropConfig(cropConfig)}
            crossorigin="anonymous" // to avoid CORS-related problems
        />
    );
}

ImageCropper.defaultProps = {
    onImageCropped: () => {}
};

export default ImageCropper;
